import React from "react";

const BookingInfo = ({
  bookingInfo,
  formatDate,
  tourInfo,
  formattedDateTime,
}) => {
  return (
    <div className="pb-4 border-bottom mb-4">
      <h6 className="mb-2">Thông tin tour đã đặt</h6>
      <div className="row g-3">
        <div className="col-lg-3">
          <h6 className="fs-14">Điểm xuất phát</h6>
          <p className="text-gray-6 fs-16 ">{tourInfo.departureLocation}</p>
        </div>
        <div className="col-lg-3">
          <h6 className="fs-14">Số ngày</h6>
          <p className="text-gray-6 fs-16 ">
            {tourInfo.numberDay} Ngày, {tourInfo.numberDay - 1} Đêm
          </p>
        </div>
        <div className="col-lg-3">
          <h6 className="fs-14">Đặt vào lúc</h6>
          <p className="text-gray-6 fs-16 ">
            {formatDate(bookingInfo.bookingDate)}
          </p>
        </div>
        <div className="col-lg-3">
          <h6 className="fs-14">Ngày bắt đầu</h6>
          <p className="text-gray-6 fs-16 ">
            {formattedDateTime(bookingInfo.startDate)}
          </p>
        </div>
        <div className="col-lg-3">
          <h6 className="fs-14">Ngày kết thúc</h6>
          <p className="text-gray-6 fs-16 ">
            {formattedDateTime(bookingInfo.endDate)}
          </p>
        </div>
        <div className="col-lg-3">
          <h6 className="fs-14">Số người đi</h6>
          <p className="text-gray-6 fs-16 ">{bookingInfo.quantity}</p>
        </div>
      </div>
    </div>
  );
};

export default BookingInfo;
